export default "__VITE_ASSET__uAaS7RKc__"